import fetch from '@/utils/fetch';
import {shop_url} from '@/global';

const GET_USERS = `${shop_url}/shop/cms/smartPark/user/findByPage`;
const GET_USER_COUNT = `${shop_url}/shop/cms/smartPark/user/count`;
const FROZEN_USER = `${shop_url}/shop/cms/smartPark/user/freezeUser/`;
const DEL_USER = `${shop_url}/shop/cms/smartPark/user/deleteUser/`;

export const getUsers = (data,page,pageCount)=>{
  return fetch({
    url:GET_USERS+`?name=${data.name}&phone=${data.phone}&role=${data.type}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`,
    method:'get'
  })
}
/**
 * 获取用户管理首页的统计信息
 */
export const getUserCount = ()=>{
    return fetch({
      url:GET_USER_COUNT,
      method:'get'
    })

}

export const frozenUser = (id,type,status)=>{
  return fetch({
    url:FROZEN_USER+id+"/"+type+"/"+status,
    method:'put'
  })

}

export const dleUser = (id,type)=>{
  return fetch({
    url:DEL_USER+id+"/"+type,
    method:'put'
  })
}



// WEBPACK FOOTER //
// ./src/api/user/index.js